import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Stack,
} from '@mui/material';
import InfoToolTip from 'containers/common/components/InfoToolTip';

function PendingRequestsSkeleton() {
  const rows = 3; // Show 3 skeleton rows

  return (
    <Box>
      <Typography variant="pageTitle" mb={3}>
        Pending Access Requests
        <InfoToolTip title="Manage pending access requests" />
      </Typography>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(rows)].map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant="text" width={150} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={250} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={80} height={24} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 3.5 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default PendingRequestsSkeleton;
